import { Button } from "@mui/material";
import { CustomQuotesHeaderText, RequestQuoteButtonText } from "constants/text";
import AddIcon from "@mui/icons-material/Add";
import ViewQuoteTable from "components/CustomQuote/ViewQuoteTable/ViewQuoteTable.tsx";
import { useDialog } from "hooks/useDialog";
import { DialogTracking } from "components/Dialog/components/DialogTracking.ts";
import CustomQuoteRequestTable from "components/CustomQuote/CustomQuoteRequestTable.tsx";
import { useGetUserDetailsQuery } from "features/api/userApi.ts";
import { CustomQuoteLandingPageContent, CustomQuoteLandingPageHeader } from "./CustomQuoteLandingPage.styles";
import { useCustomQuotes } from "hooks/useCustomQuotes.ts";
import { useEffect, useState } from "react";
import { models } from "types/api/viewModels.ts";
import { UserRole } from "types/declarations/enums.ts";

export interface QuoteFilterOpts {
	designers: string[];
	productLines: string[];
	status: string[];
	hasStatusTriggered: boolean;
}

const CustomQuoteLandingPage = () => {
	const { openDialog } = useDialog();
	const { data: userDetails } = useGetUserDetailsQuery();
	const { customQuotes, isCustomQuotesLoading, customQuotesTrigger } = useCustomQuotes();
	const [openCustomQuotes, setOpenCustomQuotes] = useState<models["CustomQuoteViewModel"][] | null>();

	const handleCreateNewQuote = () => {
		openDialog({ dialogStatus: DialogTracking.CUSTOM_QUOTE_ADD_GLOBALS });
	};

	useEffect(() => {
		customQuotesTrigger("");
		setOpenCustomQuotes(customQuotes);
	}, [customQuotes]); // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<div>
			<CustomQuoteLandingPageHeader>
				<h1>{CustomQuotesHeaderText}</h1>
				{userDetails?.role !== UserRole.QUOTER && (
					<Button
						onClick={handleCreateNewQuote}
						data-testid="start-new-custom-quote-button"
						variant="outlined"
						startIcon={<AddIcon fontSize="small" />}
					>
						{RequestQuoteButtonText}
					</Button>
				)}
			</CustomQuoteLandingPageHeader>
			<CustomQuoteLandingPageContent>
				{userDetails?.role !== UserRole.QUOTER && openCustomQuotes && (
					<ViewQuoteTable
						customQuotes={openCustomQuotes}
						isLoading={isCustomQuotesLoading}
						userDetails={userDetails}
					/>
				)}
				{userDetails?.role === UserRole.QUOTER && openCustomQuotes && (
					<CustomQuoteRequestTable
						customQuotes={openCustomQuotes}
						isLoading={isCustomQuotesLoading}
					/>
				)}
			</CustomQuoteLandingPageContent>
		</div>
	);
};

export default CustomQuoteLandingPage;
